import * as firebase from 'firebase'
let firebaseConfig = {
  apiKey: 'AIzaSyAcJLDq3cPAehG0q4uS1_Xd3q2QuICb_FU',
  authDomain: 'ennoshita-dev.firebaseapp.com',
  databaseURL: 'https://ennoshita-dev.firebaseio.com',
  projectId: 'ennoshita-dev',
  storageBucket: 'ennoshita-dev.appspot.com',
  messagingSenderId: '236136415644',
  appId: '1:236136415644:web:754e37face939ff8d58859'
}

if (process.env.STAGE === 'production') {
  firebaseConfig = {
    apiKey: 'AIzaSyAdrK54sHFPEGqAZE2soMBKLW0kdDlb-wk',
    authDomain: 'ennoshita-e8a3f.firebaseapp.com',
    databaseURL: 'https://ennoshita-e8a3f.firebaseio.com',
    projectId: 'ennoshita-e8a3f',
    storageBucket: 'ennoshita-e8a3f.appspot.com',
    messagingSenderId: '379049683349',
    appId: '1:379049683349:web:17e400abb7c3076798ee9c'
  }
} else if (process.env.STAGE === 'staging') {
  firebaseConfig = {
    apiKey: 'AIzaSyC5LId82eLNfTQ8Q2k2gNMj5krsjCprbZk',
    authDomain: 'ennoshita-staging.firebaseapp.com',
    databaseURL: 'https://ennoshita-staging.firebaseio.com',
    projectId: 'ennoshita-staging',
    storageBucket: 'ennoshita-staging.appspot.com',
    messagingSenderId: '562436953579',
    appId: '1:562436953579:web:347f6ac8a4c5b8753835ae'
  }
}

const firebaseApp = firebase.initializeApp(firebaseConfig)

export const firestore = firebaseApp.firestore()
